"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.IconBrushOutline = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var IconBrushOutline = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '24px' : _b, style = _a.style;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: __assign(__assign({ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }, style), { height: size, width: size }) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                position: 'relative',
                height: 0,
                width: '100%',
                padding: 0,
                paddingBottom: '100%'
            } }, { children: (0, jsx_runtime_1.jsx)("svg", __assign({ style: {
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    left: 0,
                    top: 0
                }, viewBox: "0 0 512 512", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M452.37 59.63h0a40.49 40.49 0 00-57.26 0L184 294.74c23.08 4.7 46.12 27.29 49.26 49.26l219.11-227.11a40.49 40.49 0 000-57.26zM138 336c-29.88 0-54 24.5-54 54.86 0 23.95-20.88 36.57-36 36.57C64.56 449.74 92.82 464 120 464c39.78 0 72-32.73 72-73.14 0-30.36-24.12-54.86-54-54.86z", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "32" }, void 0) }), void 0) }), void 0) }), void 0));
};
exports.IconBrushOutline = IconBrushOutline;
